import clsx from 'clsx'
import type { ComponentPropsWithoutRef, ComponentType, ReactNode, SVGProps } from 'react'
import { themeClasses } from '../shared/themeClasses'

type EmptyStateIcon = ComponentType<SVGProps<SVGSVGElement>>

interface EmptyStateProps extends Omit<ComponentPropsWithoutRef<'div'>, 'title'> {
  description?: ReactNode
  descriptionClassName?: string
  icon?: EmptyStateIcon
  iconClassName?: string
  title: ReactNode
  titleClassName?: string
}

export function EmptyState({
  className,
  description,
  descriptionClassName,
  icon: Icon,
  iconClassName,
  title,
  titleClassName,
  children,
  ...props
}: EmptyStateProps) {
  return (
    <div {...props} className={clsx('py-6 text-center', className)}>
      {Icon ? <Icon aria-hidden="true" className={clsx('mx-auto size-8', themeClasses.textFaint, iconClassName)} /> : null}
      <p className={clsx('mt-3 text-sm/6 font-medium', themeClasses.textMuted, titleClassName)}>{title}</p>
      {description ? <p className={clsx('mt-1 text-xs/5', themeClasses.textMuted, descriptionClassName)}>{description}</p> : null}
      {children ? <div className="mt-4 flex justify-center">{children}</div> : null}
    </div>
  )
}
